import { Wifi, Check, FileText, Shield } from "lucide-react";
import { COMPANY_INFO } from "../data/constants";

export const PackageCard = ({ pkg, type }) => {
  return (
    <div
      className={`package-card bg-white rounded-3xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 card-hover ${
        pkg.popular ? "ring-2 ring-orange-500" : ""
      }`}
      data-testid={`package-card-${pkg.speed}`}
    >
      {pkg.popular && <div className="popular-badge">Más Popular</div>}
      
      <div className="text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-100 rounded-2xl mb-6">
          <Wifi className="w-8 h-8 text-orange-500" />
        </div>
        
        <div className="text-6xl font-bold text-gray-900 mb-2">{pkg.speed}</div>
        <div className="text-xl text-gray-500 mb-6">Mbps</div>
        
        <div className="mb-8">
          <span className="text-4xl font-bold text-gray-900">${pkg.price}</span>
          <span className="text-gray-500">/mes</span>
        </div>
        
        <ul className="text-left space-y-3 mb-8">
          <li className="flex items-center gap-3 text-gray-600">
            <Check className="w-5 h-5 text-green-500 flex-shrink-0" />
            Configuración incluida
          </li>
          <li className="flex items-center gap-3 text-gray-600">
            <Check className="w-5 h-5 text-green-500 flex-shrink-0" />
            Precios con IVA incluido
          </li>
          <li className="flex items-center gap-3 text-gray-600">
            <Check className="w-5 h-5 text-green-500 flex-shrink-0" />
            Soporte técnico
          </li>
          {type === "hogar" && (
            <li className="flex items-center gap-3 text-gray-600">
              <Check className="w-5 h-5 text-green-500 flex-shrink-0" />
              Para toda tu familia
            </li>
          )}
          {type === "negocios" && pkg.features && pkg.features.map((feature, idx) => (
            <li key={idx} className="flex items-center gap-3 text-gray-600">
              {feature.includes("Facturación") ? (
                <FileText className="w-5 h-5 text-green-500 flex-shrink-0" />
              ) : (
                <Shield className="w-5 h-5 text-green-500 flex-shrink-0" />
              )}
              {feature}
            </li>
          ))}
        </ul>
        
        <a
          href={COMPANY_INFO.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          className={`block w-full py-4 rounded-full font-semibold transition-all ${
            pkg.popular
              ? "bg-gradient-to-r from-orange-500 to-orange-600 text-white hover:shadow-lg hover:shadow-orange-500/30"
              : "bg-gray-100 text-gray-900 hover:bg-orange-500 hover:text-white"
          }`}
          onClick={() => window.trackEvent && window.trackEvent('click', 'Package', `${type}_${pkg.speed}mbps_$${pkg.price}`)}
        >
          ¡Contrata Ahora!
        </a>
      </div>
    </div>
  );
};
